module.exports = __webpack_public_path__ + "static/media/home_icon.c7395c2b.svg";